import React from 'react';
import PropTypes from 'prop-types';

import { truncateWallet, formatDate } from '../../utils';
import Status from './Status';
import styles from './index.module.css';

const Row = ({ withdrawal }) => {
  const { date, wallet, network, amount, convertedAmount, status } = withdrawal;

  return (
    <tr className={styles.row}>
      <td className={styles.cell}>
        <span className={styles.date}>{formatDate(date)}</span>
      </td>
      <td className={styles.cell}>
        <span>{truncateWallet(wallet)}</span>
      </td>
      <td className={styles.cellNetwork}>
        <span>{network}</span>
      </td>
      <td className={styles.cellAmount}>
        <div className={styles.amountContainer}>
          <span className={styles.amountPrimary}>
            {amount.value} {amount.currency}
          </span>
          <span className={styles.amountSecondary}>
            {convertedAmount.value} {convertedAmount.currency}
          </span>
        </div>
      </td>
      <td className={styles.cellStatus}>
        <Status value={status} />
      </td>
    </tr>
  );
};

Row.propTypes = {
  withdrawal: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    wallet: PropTypes.string.isRequired,
    network: PropTypes.string.isRequired,
    amount: PropTypes.shape({
      value: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
    convertedAmount: PropTypes.shape({
      value: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default Row;
